import React, { Component } from 'react';
import { Droppable, Draggable } from 'react-beautiful-dnd';
import DeveloperCard from 'components/DeveloperCard';
import developers from 'data/developers';

const getItemStyle = (isDragging, draggableStyle) => ({
  userSelect: 'none',
  alignItems: 'center',
  justifyContent: 'center',
  margin: 5,
  ...draggableStyle,
});

class DeveloperPicker extends Component {
  state = {
    drawerVisible: false,
  };

  showDrawer = () => {
    if (!this.state.drawerVisible) {
      this.setState({ drawerVisible: true });
    }
  };

  hideDrawer = () => {
    this.setState({ drawerVisible: false });
  };

  render() {
    return (
      <div
        onClick={this.showDrawer}
        className="developer-drawer"
        style={{
          ...styles.container,
          ...(this.state.drawerVisible ? {} : { right: '-97%', bottom: 0 }),
        }}
      >
        <Droppable
          isDropDisabled={true}
          droppableId={'drawer'}
          direction="horizontal"
        >
          {(provided, snapshot) => (
            <div ref={provided.innerRef} style={styles.developerList}>
              {developers.map((person, index) => (
                <Draggable
                  key={person.id}
                  isNew={true}
                  draggableId={person.id}
                  index={true}
                >
                  {(provided, snapshot) => (
                    <div
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                      style={{
                        ...getItemStyle(
                          snapshot.isDragging,
                          provided.draggableProps.style,
                        ),
                      }}
                    >
                      <DeveloperCard
                        isDragging={snapshot.isDragging}
                        developer={person}
                      />
                    </div>
                  )}
                </Draggable>
              ))}
              <span style={styles.closeButton} onClick={this.hideDrawer}>
                {'✖️'}
              </span>
            </div>
          )}
        </Droppable>
      </div>
    );
  }
}

const styles = {
  container: {
    zIndex: 12,
    width: '100%',
    bottom: 0,
    borderTop: '1px solid #777',
    borderLeft: '1px solid #777',
    borderBottom: '1px solid #777',
    background: '#fff',
    position: 'fixed',
    boxShadow: '-2px -2px 3px #99999944',
  },
  closeButton: {
    alignSelf: 'center',
    cursor: 'pointer',
    padding: '1rem',
    flex: 1,
    display: 'flex',
  },
  developerList: {
    display: 'flex',
    flexDirection: 'row',
    flex: 1,
    flexWrap: 'wrap',
    alignItems: 'flex-start',
    justifyContent: 'center',
    background: 'white',
    width: '100%',
    border: 'none',
  },
};

export default DeveloperPicker;



// WEBPACK FOOTER //
// ./src/components/DeveloperPicker/DeveloperPicker.js